module.exports = __webpack_public_path__ + "static/focus-b0f225efe8c0cef0087851da3f188e4d.mp4";